<script setup lang="ts">
type CurrencyFormatProps = {
  value?: string | number
  decimal?: number
  showSymbol?: boolean
}

const props = withDefaults(defineProps<CurrencyFormatProps>(), { decimal: 2, showSymbol: true })
const locale = useI18n().locale.value
</script>

<template>
  <span v-if="value !== undefined && value !== null" class="currency-format">
    <span v-if="showSymbol && locale !== 'fr'" class="currency-symbol">$</span
    >{{
      isNaN(Number(value))
        ? value
        : decimal
          ? Number(value).toLocaleString(localeConfig[locale].code, {
              minimumFractionDigits: decimal,
              maximumFractionDigits: decimal,
            })
          : Number(value).toLocaleString(localeConfig[locale].code)
    }}<span v-if="showSymbol && locale === 'fr'" class="currency-symbol currency-symbol__fr">$</span>
  </span>
</template>

<style lang="postcss">
.currency-symbol__fr {
  padding-left: 0.2em;
}
</style>
